import React from 'react';
import HeadingBlock from '$/components/global/heading';
import TranscriptsGrid from '$/components/transcripts-grid';

const Transcripts: React.FC<any> = () => {
  return (
    <React.Fragment>
      <section>
        <div className="transcript_list">
          <HeadingBlock title={'Manage Transcriptions'} />
          <TranscriptsGrid />
        </div>
      </section>
    </React.Fragment>
  );
};

export default Transcripts;
